// import { loadState } from '../store/localStorage'
//
// const persistentState = loadState()
const persistentState = {};

const mockState = {
  feedback: [],
  // auth: {isLogged: false},
  context: { sessionId: null, dummy2: null },
  command: { commands: [], autoplay: true },
};

export default { ...mockState, ...persistentState };



// WEBPACK FOOTER //
// ./src/redux/reducers/initialState.js